import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import GuestFeedback from "@/pages/GuestFeedback";
import AdminDashboard from "@/pages/AdminDashboard";
import MasterAdmin from "@/pages/MasterAdmin";
import NotFound from "@/pages/NotFound";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Tanitim from "@/pages/Tanitim";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(18, 14, 29, 0.96)",
            color: "#f4f1fb",
            border: "1px solid rgba(196, 181, 253, 0.22)",
            borderRadius: "14px",
            boxShadow: "0 20px 50px -12px rgba(0,0,0,.8), 0 0 40px -10px rgba(124,58,237,.5)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          {/* Hotel Admin Dashboard */}
          <Route path="/admin" element={<AdminDashboard />} />
          
          {/* Marketing pages: Turkish at /, English at /en, Serbian at /sr */}
          <Route path="/en" element={<Landing lang="en" />} />
          <Route path="/sr" element={<Landing lang="sr" />} />
          <Route path="/tanitim" element={<Tanitim />} />
          <Route path="/video" element={<Tanitim />} />
          <Route path="/gizlilik" element={<Privacy />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Master Admin (hidden) */}
          <Route path="/master-admin" element={<MasterAdmin />} />
          
          {/* Guest routes with hotel slug */}
          <Route path="/:hotelSlug/room/:roomNumber" element={<GuestFeedback />} />
          <Route path="/:hotelSlug/:roomNumber" element={<GuestFeedback />} />
          <Route path="/:hotelSlug" element={<GuestFeedback />} />
          
          {/* Marketing landing page with demo request form */}
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
